import React, { useState } from "react";
import "./pricing.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateOnboardingInfo } from "../../../redux/attorneyOnboardingSlice";
// StepFooter removed since this is now a settings page component
import IconCheckbox from "../../../components/input/new/iconCheckbox";
import PaymentMethodModal from "./paymentMethodModal";

const Pricing = () => {
  const [acknowledgePricing, setAcknowledgePricing] = useState(false);
  const [acknowledgePaymentMethod, setAcknowledgePaymentMethod] = useState(false);
  const [selectedTab, setSelectedTab] = useState("pricing");
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);

  const userId = useSelector(
    (state) => state.attorneyData.attorneyData?.user_id
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNext = () => {
    dispatch(
      updateOnboardingInfo({
        pricingAcknowledged: acknowledgePricing,
        paymentMethodAcknowledged: acknowledgePaymentMethod,
      })
    );
  };

  const isFooterDisabled = !acknowledgePricing || !acknowledgePaymentMethod;

  return (
    <div className="pricing-container">
      <div className="pricing-content">
        <div className="pricing-header">
          <h1>Pricing</h1>
          <div className="pricing-tabs">
            <button
              className={`tab-button ${selectedTab === "pricing" ? "active" : ""}`}
              onClick={() => setSelectedTab("pricing")}
            >
              Pricing and policies
            </button>
            <button
              className={`tab-button ${selectedTab === "payment" ? "active" : ""}`}
              onClick={() => setSelectedTab("payment")}
            >
              Payment methods
            </button>
          </div>
        </div>

        {selectedTab === "pricing" && (
          <div className="pricing-section">
            <div className="pricing-content-left">
              <div className="pricing-info">
                <h2>Pricing</h2>
                <p>
                  There are no upfront fees or subscription costs for joining Quidpro's Marketplace - you pay only when a new client books an appointment with you.
                </p>
              </div>

              <div className="pricing-info">
                <h2>How and when you're charged on the Marketplace:</h2>
                <ul>
                  <li>A booking fee is charged for each <strong>new</strong> client booking received through the Marketplace.</li>
                  <li>No charge is applied for clients who have previously seen the same attorney.</li>
                  <li>This one-time fee applies regardless of the appointment outcome (e.g., whether a client attends or is a no-show).</li>
                </ul>
                <p>
                  Visit our <a href="#" className="help-center-link">Help Center</a> for more information on our pricing model, policies, and how Quidpro helps to minimize cancellations and no-shows.
                </p>
              </div>

              <div className="pricing-box">
                <h3>Quidpro Marketplace</h3>
                <div className="pricing-item">
                  <div className="pricing-item-content">
                    <h4>New client bookings</h4>
                    <p>Receive bookings from new clients through Quidpro.com or the Quidpro mobile app.</p>
                    <button className="calculate-button">Calculate my yearly new client revenue</button>
                    <p className="pricing-note">New client booking fees vary based on practice area and location.</p>
                  </div>
                  <div className="pricing-item-right">
                    <div className="price-display">
                      <span className="price">$--*</span>
                      <span className="price-unit">per new client, per attorney</span>
                    </div>
                    <a href="#" className="show-price-link">Show price by attorney</a>
                   
                  </div>
                </div>

                <div className="pricing-item">
                  <div className="pricing-item-content">
                    <h4>Existing client bookings</h4>
                    <p>Bookings made by existing clients or made directly through your website are free.</p>
                  </div>
                  <div className="pricing-item-right">
                    <span className="free-label">Free</span>
                  </div>
                </div>
              </div>

              <div className="additional-products">
                <h3>Your additional products</h3>
                
                <div className="pricing-item">
                  <div className="pricing-item-content">
                    <h4>Book Online Button</h4>
                    <p>Give clients an easy way to book from your website 24/7. Website bookings are free.</p>
                  </div>
                  <div className="pricing-item-right">
                    <span className="free-label">Free</span>
                  </div>
                </div>

                <div className="pricing-item">
                  <div className="pricing-item-content">
                    <h4>Intake</h4>
                    <p>Collect your office forms before the appointment.</p>
                  </div>
                  <div className="pricing-item-right">
                    <span className="free-label">Free</span>
                  </div>
                </div>

                <div className="pricing-item">
                  <div className="pricing-item-content">
                    <h4>Video service</h4>
                    <p>See clients virtually with an integrated, secure video experience.</p>
                  </div>
                  <div className="pricing-item-right">
                    <span className="free-label">Free</span>
                  </div>
                </div>
              </div>

              <div className="faq-section-pricing">
                <h3>FAQs</h3>
                <div className="faq-item">
                  <span>What is included in my bill?</span>
                  <span className="chevron">▼</span>
                </div>
                <div className="faq-item">
                  <span>What happens if a client reschedules, cancels, or doesn't show up for their appointment?</span>
                  <span className="chevron">▼</span>
                </div>
                <div className="faq-item">
                  <span>How is the price for each attorney calculated?</span>
                  <span className="chevron">▼</span>
                </div>
                <div className="faq-item">
                  <span>How can I control my monthly spend?</span>
                  <span className="chevron">▼</span>
                </div>
              </div>

              <div className="contact-info">
                <p>For more information on pricing, <a href="#" className="contact-link">contact us</a></p>
              </div>
            </div>
          </div>
        )}

        {selectedTab === "payment" && (
          <div className="payment-section">
            <div className="payment-content-left">
              <div className="payment-info">
                <h2>Payment methods for practice</h2>
                <p>Please add at least one payment method.</p>
                <button 
                  className="add-payment-button"
                  onClick={() => setIsPaymentModalOpen(true)}
                >
                  Add new
                </button>
              </div>

              <div className="business-info">
                <div className="info-section">
                  <h3>Primary business address</h3>
                  <div className="info-content">
                    <p>No primary business address</p>
                    <a href="#" className="edit-link">Edit</a>
                  </div>
                </div>

                <div className="info-section">
                  <h3>Billing email</h3>
                  <div className="info-content">
                    <p>No billing email</p>
                    <a href="#" className="edit-link">Edit</a>
                  </div>
                </div>
              </div>
            </div>

            <div className="payment-content-right">
              <div className="bills-box">
                <h3>View your bills</h3>
                <p>You don't have any bills yet. When you receive bills, you'll see them here.</p>
              </div>
            </div>
          </div>
        )}
      </div>
      
      <PaymentMethodModal 
        isOpen={isPaymentModalOpen}
        onClose={() => setIsPaymentModalOpen(false)}
      />
    </div>
  );
};

export default Pricing; 